import { Routes } from '@angular/router';
import { Page404Component } from './shared/pages/page404/page404.component';
import { Page403Component } from './shared/pages/page403/page403.component';
import { Page500Component } from './shared/pages/page500/page500.component';
import { Page503Component } from './shared/pages/page503/page503.component';
import { AuthFlowGuard } from './core/guards/auth-fllow.guard';

export const routes: Routes = [
	{
		path: 'auth',
		loadComponent: () => import('../app/modules/auth/auth.component'),
		children: [
			{
				path: 'login',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () => import('./modules/auth/pages/login/login.component'),
			},
			{
				path: 'forgot',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () => import('./modules/auth/pages/forgot-password/forgot-password.component'),
			},
			{
				path: 'use-terms',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () => import('./modules/auth/pages/use-terms/use-terms.component'),
			},
			{
				path: 'privacy-politics',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () => import('./modules/auth/pages/privacy-policies/privacy-policies.component'),
			},
			{
				path: 'create-new-account',
				title: 'Package Hub',
				data: { 
					translate: 'menu-auth.login',
				},
				loadComponent: () =>
					import(
						'./modules/auth/pages/create-new-account/create-new-account.component'
					),
			},
			{
				path: 'identify-property',
				canActivate: [AuthFlowGuard],
				title: 'Package Hub',
				data: { 
					translate: 'menu-auth.login',
					requiredStep: 2
				},
				loadComponent: () =>
					import(
						'./modules/auth/pages/identify-property/identify-property.component'
					),
			},
			{
				path: 'set-email',
				canActivate: [AuthFlowGuard],
				title: 'Package Hub',
				data: { 
					translate: 'menu-auth.login',
					requiredStep: 3 
				},
				loadComponent: () =>
					import(
						'./modules/auth/pages/set-email/set-email.component'
					),
			},
			{
				path: 'set-password',
				canActivate: [AuthFlowGuard],
				title: 'Set password to account',
				data: { 
					translate: 'menu.auth.login',
					requiredStep: 4
				},
				loadComponent: () =>
					import(
						'./modules/auth/pages/set-password-to-account/set-password-to-account.component'
					),
			},

			{
				path: 'forgot-password/:t',
				title: 'Package Hub',
				data: { translate: 'menu-auth.login' },
				loadComponent: () =>
					import(
						'./modules/auth/pages/forgot-password/forgot-password.component'
					),
			},

			{ path: '', redirectTo: 'login', pathMatch: 'full' },
		],
	},
	{
		path: 'dashboard',
		loadComponent: () => import('./modules/dashboard/dashboard.component'),
		children: [
			{
				path: 'home',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/home/home.component'),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'services',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/services/services.component'),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'activity',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/activity/activity.component'),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'order-detail',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/order-detail/order-detail.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'manual-to-recolect',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/components/order-detail-components/tutorial-to-recolect/tutorial-to-recolect.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'scheduled-package',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/scheduled-package/scheduled-package.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'pending-payment',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/pending-payment/pending-payment.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'expired-package',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/expired-package/expired-package.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'locker-locations',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/locker-locations/locker-locations.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'locker-detail',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/locker-detail-information/locker-detail-information.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'property-detail',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/property-detail-information/property-detail-information.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'orders',
				title: 'Package Hub',
				loadComponent: () =>
					import('./modules/dashboard/pages/orders/orders.component'),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'preferences',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/preferences/preferences.component'
					),
				data: {
					translate: 'menu-dashboard.home',
				},
			},
			{
				path: 'account/details',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/details/details.component'
					),
			},
			{
				path: 'account/change-password',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/change-password/change-password.component'
					),
			},
			{
				path: 'account/notifications',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/notifications/notifications.component'
					),
			},
			{
				path: 'account/id',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/identificator/identificator.component'
					),
			},
			{
				path: 'account/preferences-of-locker',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/preferences-of-locker/preferences-of-locker.component'
					),
			},
			{
				path: 'account/appearance',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/appearance/appearance.component'
					),
			},
			{
				path: 'account/verify-telephone',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/verify-telephone/verify-telephone.component'
					),
			},
			{
				path: 'account/take-vacations',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/account/take-vacations/take-vacations.component'
					),
			},
			{
				path: 'support/help',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/support/help/help.component'
					),
			},
			{
				path: 'support/help/tutorial',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/support/help-tutorial/help-tutorial.component'
					),
			},
			{
				path: 'support/terms',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/support/terms/terms.component'
					),
			},
			{
				path: 'support/about',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/support/about/about.component'
					),
			},
			{
				path: 'support/delete',
				title: 'Package Hub',
				loadComponent: () =>
					import(
						'./modules/dashboard/pages/support/delete//delete.component'
					),
			},
			{ path: '', redirectTo: '/home', pathMatch: 'full' },
		],
	},
	{
		path: '403',
		component: Page403Component,
	},
	{
		path: '404',
		component: Page404Component,
	},
	{
		path: '500',
		component: Page500Component,
	},
	{
		path: '503',
		component: Page503Component,
	},
	{ path: '', redirectTo: '/auth/login', pathMatch: 'full' },
	{ path: '**', redirectTo: '/404', pathMatch: 'full' },
];
